import React from "react";
import { Box, Typography } from "@mui/material";

export default function CrmExportConflicts({ conflicts }) {
  if (!conflicts.length) return null;
  return (
    <Box sx={{ mt: 2, overflowWrap: "anywhere" }}>
      <Typography sx={{ fontWeight: 600 }}>Existing values kept in HubSpot</Typography>
      {conflicts.map((conflict, index) => (
        <Box key={index} sx={{ py: 1, borderBottom: "1px solid", borderColor: "divider" }}>
          <Typography variant="body2">{conflict.record_key} · {conflict.field}</Typography>
          <Typography variant="body2">AlphaSearch: {String(conflict.ours ?? "Empty")}</Typography>
          <Typography variant="body2">HubSpot: {String(conflict.theirs ?? "Empty")}</Typography>
        </Box>
      ))}
    </Box>
  );
}
